export default __webpack_public_path__ + "static/media/freddy-janssens.1f0400b0.png";